import h, { FunctionComponent } from 'preact';

const BasketTableHeader: FunctionComponent<BasketTableHeaderProps> = () => {
    return <thead class="basket__head bg-blue d-none d-lg-table-header-group">
        <tr class="text-white font-weight-bold">
            <th class="basket__head__item border-left" scope="col">Product</th>
            <th class="basket__head__size" scope="col">Size</th>
            <th class="basket__head__colour" scope="col">Colour</th>
            <th scope="col">Price</th>
            <th class="basket__head__quantity" scope="col">Quantity</th>
            <th class="border-right" scope="col">Subtotal</th>
        </tr>
        </thead>
    ;
};

interface BasketTableHeaderProps {
}

export default BasketTableHeader;
